/**
 * 
 * @param {string} key 
 * @param {*} data 
 */
export const setData = (key, data) => {
  window.sessionStorage.setItem(key, JSON.stringify(data))
}
/**
 * 
 * @param {string} key
 * @returns {*}
 */
export const getData = key => {
  return JSON.parse(window.sessionStorage.getItem(key))
}
/**
 * 
 * @param {string} key
 * 
 */
export const removeData = key => {
  window.sessionStorage.removeItem(key)
}